import { render, staticRenderFns } from "./ProtocolLink.vue?vue&type=template&id=5dcdbd3d&scoped=true&"
import script from "./ProtocolLink.vue?vue&type=script&lang=js&"
export * from "./ProtocolLink.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolLink.vue?vue&type=style&index=0&id=5dcdbd3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdbd3d",
  null
  
)

export default component.exports